import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
// material
import {
  Box,
  Grid,
  Container,
  Typography,
  Card,
  CardContent,
  Stack
} from "@mui/material";
// components
import Page from "../components/Page";
import {
  ExtensionAdminTable,
  ResearchPeriodExtensionTable
} from "../components/_dashboard/app";
import {
  getResearchExtensionMentor,
  getResearchExtensionAdmin
} from "../core/service/researchExtension.service";
// ----------------------------------------------------------------------
const ROLE_ADMIN = "admin";
const ROLE_MENTOR = "mentor";
const ROLE_PHD_3Y = "phd_3y";
const ROLE_PHD_5Y = "phd_5y";
const ROLE_POSTDOC = "post_doc";

export default function Extension() {
  const navigate = useNavigate();
  const { role, user: currentUser } = useSelector((state) => state.authReducer);
  const { id } = currentUser;
  const [listResearchExtension, setListResearchExtension] = useState([{}]);
  const { entities } = listResearchExtension;

  const researchExtensionnMentor = async (id) => {
    const data = await getResearchExtensionMentor(id);
    setListResearchExtension(data);
  };

  const researchExtensionnAdmin = async () => {
    const data = await getResearchExtensionAdmin();
    setListResearchExtension(data);
  };

  useEffect(() => {
    if (currentUser?.role === ROLE_ADMIN) {
      // navigate("/404", { replace: true });
      researchExtensionnAdmin();
    } else {
      researchExtensionnMentor(id);
    }
  }, []);

  const totalPostDoc = entities?.filter((e) => e.role_nm === "post_doc").length;
  const totalPhD = entities?.filter((e) => e.role_nm !== "post_doc").length;

  return (
    <Page title="Research Period Extension">
      <Container maxWidth="xl">
        <Grid container spacing={3}>
          {role === ROLE_ADMIN ? (
            <>
              <Grid item xs={12} md={6} lg={12}>
                <Container>
                  <Card>
                    <CardContent>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          p: 1,
                          m: 1,
                          bgcolor: "background.paper",
                          borderRadius: 1
                        }}
                      >
                        <Stack direction="row" spacing={6}>
                          <Typography variant="subtitle2">All:</Typography>
                          <Typography>{entities?.length}</Typography>
                        </Stack>
                        <Stack direction="row" spacing={6}>
                          <Typography variant="subtitle2">
                            Total Postdoc:
                          </Typography>
                          <Typography>{totalPostDoc}</Typography>
                        </Stack>
                        <Stack direction="row" spacing={6}>
                          <Typography variant="subtitle2">
                            Total PhD:
                          </Typography>
                          <Typography>{totalPhD}</Typography>
                        </Stack>
                      </Box>
                    </CardContent>
                  </Card>
                </Container>
              </Grid>

              <Grid item xs={12} md={6} lg={12} sx={{ marginTop: 5 }}>
                <ExtensionAdminTable listExtension={entities || []} />
              </Grid>
            </>
          ) : (
            role === ROLE_MENTOR && (
              <Grid item xs={12} md={6} lg={12}>
                <ResearchPeriodExtensionTable extension={entities || []} />
              </Grid>
            )
          )}
        </Grid>
      </Container>
    </Page>
  );
}
